import { render } from "./EventRecords.vue?vue&type=template&id=f4bcbb76&scoped=true"
import script from "./EventRecords.vue?vue&type=script&lang=js"
export * from "./EventRecords.vue?vue&type=script&lang=js"

import "./EventRecords.vue?vue&type=style&index=0&id=f4bcbb76&scoped=true&lang=scss"

import exportComponent from "/home/brant/git/HeySensCloudWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4bcbb76"]])

export default __exports__